module.exports = __webpack_public_path__ + "img/ic_32_gender_woman.22947b9a.svg";